import React from "react";
import { Box } from "@chakra-ui/react";
import { useColorModeValue } from "../components/ui/color-mode";
import { useAuth0 } from "@auth0/auth0-react";
import { useRecentStocks } from "../hooks/useRecentStocks";
import HomeFooter from "./HomeFooter";
import HomeMarketingContent from "./HomeMarketingContent";
import HomeRecentStocksSection from "./HomeRecentStocksSection";

// ---------------- Browse page -------------
const Home = () => {
  const { isAuthenticated } = useAuth0();
  const { recents, loading: recentsLoading, error: recentsError, addRecent } = useRecentStocks();

  const handleSuggestionSelected = async (suggestion) => {
    if (suggestion?.entity_type === "pre_ipo" || !suggestion?.ticker) return;
    try {
      await addRecent?.(suggestion.ticker);
    } catch (err) {
      console.error("Failed to record recent stock", err);
    }
  };

  const pageBg = useColorModeValue("gray.50", "gray.950");
  const textColor = useColorModeValue("gray.800", "white");

  return (
    <Box bg={pageBg} color={textColor}>
      <HomeMarketingContent onSuggestionSelected={handleSuggestionSelected} />
      {isAuthenticated && (
        <HomeRecentStocksSection
          recents={recents}
          loading={recentsLoading}
          error={recentsError}
        />
      )}
      <HomeFooter />
    </Box>
  );
};

export default Home;
